import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow } from "@devexpress/dx-react-grid-material-ui";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import Loading from "../../../../componentes/Loading/Loading";
import SnackMessage from "../../../../componentes/SnakBar";
import {
  GetDocumentosPosicaoContratoDocument,
  GetDocumentosPosicaoContratoComponent,
  RejeitarDocumentoComponent
} from "../../../../graphql/components";

interface Props {
  codPessoaPai: number | undefined;
  codOperadora: number | undefined;
}

const columns = [
  { name: "coddocumentos", title: "Código" },
  { name: "nome", title: "Nome" },
  { name: "tipo", title: "Tipo" },
  { name: "datainclusao", title: "Incluído" },
  { name: "status", title: "Status" },
  { name: "obs", title: "Obs" },
  { name: "acao", title: "Ação" }
];

const tableColumnExtensions: any[] = [
  { columnName: "coddocumentos", width: "90", align: "center" },
  { columnName: "nome", width: "25%", align: "left", wordWrapEnabled: true },
  { columnName: "tipo", width: "150", align: "left" },
  { columnName: "datainclusao", width: "160", align: "center" },
  { columnName: "status", width: "120", align: "center" },
  { columnName: "obs", width: "20%", align: "left", wordWrapEnabled: true },
  { columnName: "acao", width: "120", align: "center" }
];

const DocumentosPosicaoContrato: React.FunctionComponent<Props> = ({ codPessoaPai, codOperadora }) => {
  const [documentoEmRecusa, setDocumentoEmRecusa] = useState<any>(null);
  const [motivo, setMotivo] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackMessage, setOpenSnackMessage] = useState(false);
  const [variantSnack, setVariantSnack] = useState<"success" | "warning" | "error" | "info">("success");

  const closeSnackMessage = useCallback(() => setOpenSnackMessage(false), []);

  const abreRecusa = useCallback((documento: any) => {
    setMotivo("");
    setDocumentoEmRecusa(documento);
  }, []);

  const fechaRecusa = useCallback(() => setDocumentoEmRecusa(null), []);

  if (!codPessoaPai || !codOperadora) {
    return null;
  }

  const variablesLista = { values: { codpessoapai: codPessoaPai, codoperadora: codOperadora } };

  const AcaoFormatter = ({ row }: any) =>
    row.podeRejeitar ? (
      <Button color="secondary" size="small" onClick={() => abreRecusa(row)}>
        Recusar
      </Button>
    ) : null;

  return (
    <React.Fragment>
      <Typography variant="subtitle1" gutterBottom style={{ marginTop: 20 }}>
        Documentos
      </Typography>
      <GetDocumentosPosicaoContratoComponent variables={variablesLista}>
        {({ data, loading }) => {
          if (loading) {
            return <Loading />;
          }
          const documentos = (data && data.getDocumentosPosicaoContrato) || [];
          if (!documentos.length) {
            return (
              <Typography variant="body2" gutterBottom>
                Nenhum documento encontrado.
              </Typography>
            );
          }
          return (
            <Grid rows={documentos as any[]} columns={columns}>
              <DataTypeProvider for={["acao"]} formatterComponent={AcaoFormatter} />
              <Table columnExtensions={tableColumnExtensions} />
              <TableHeaderRow />
            </Grid>
          );
        }}
      </GetDocumentosPosicaoContratoComponent>

      <RejeitarDocumentoComponent>
        {(rejeitarDocumento, { loading }) => (
          <Dialog open={null !== documentoEmRecusa} onClose={fechaRecusa} fullWidth={true} maxWidth="sm">
            <DialogTitle>Recusar documento</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Informe o motivo da recusa do documento {documentoEmRecusa && documentoEmRecusa.nome}.
              </DialogContentText>
              <TextField
                autoFocus={true}
                fullWidth={true}
                multiline={true}
                rows={3}
                label="Motivo"
                value={motivo}
                onChange={event => setMotivo(event.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={fechaRecusa} color="primary">
                Cancelar
              </Button>
              <Button
                color="secondary"
                disabled={loading || !motivo.trim()}
                onClick={async () => {
                  try {
                    const response = await rejeitarDocumento({
                      variables: { values: { coddocumentos: documentoEmRecusa.coddocumentos, motivo: motivo.trim() } },
                      refetchQueries: [{ query: GetDocumentosPosicaoContratoDocument, variables: variablesLista }]
                    });
                    const resultado = response && response.data && response.data.rejeitarDocumento;
                    setMessage((resultado && resultado.msg) || "Não foi possível recusar o documento.");
                    setVariantSnack(resultado && resultado.sucesso ? "success" : "warning");
                    setOpenSnackMessage(true);
                    if (resultado && resultado.sucesso) {
                      fechaRecusa();
                    }
                  } catch (e) {
                    setMessage((e as Error).message);
                    setVariantSnack("error");
                    setOpenSnackMessage(true);
                  }
                }}
              >
                Recusar
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </RejeitarDocumentoComponent>

      <SnackMessage variant={variantSnack} message={message} open={openSnackMessage} close={closeSnackMessage} />
    </React.Fragment>
  );
};

export default DocumentosPosicaoContrato;
